<div class="d-flex flex-column h-100"  [formGroup]="numberGroup">
  <label class="label-preview-title">{{item.templateOptions.label}} @if (item.templateOptions.required) {
    <span>*</span>
  }</label>
  <div class="d-flex flex-column justify-content-center" style="height: 100%;">
    <div class="d-flex justify-content-center">
      <input type="number" onkeydown="return event.keyCode !== 69"  formControlName="numberFirst" class="form-control number custom-form-control" id="form-control"  placeholder="{{item.templateOptions.placeholder}}"
        autocomplete="off" description="xx">
      @if (item.templateOptions['precision']!== null && item.templateOptions['precision']) {
        <span style="margin-left:6px;margin-right:6px;padding-top: 29px;" class="label-preview">.</span>
      }
      @if (item.templateOptions['precision']!== null && item.templateOptions['precision']) {
        <input type="number" onkeydown="return event.keyCode !== 69"  formControlName="numberSecond" maxlength="2" class="form-control number custom-form-control"
          autocomplete="off" style="margin-left:2px;">
      }
      @if (item.templateOptions['unit']!== null && item.templateOptions['unit']) {
        <span style="margin-left:2px;padding-top: 13px;" class="label-preview label-form">{{item.templateOptions['unit']}}</span>
      }
    </div>
    @if (numberGroup.controls.numberOutput?.errors?.required && numberGroup.touched) {
      <p class="validation-text text-center pb-0">{{ 'MAIN.CONTENT.WORKFLOW.REQUIRED' | translate }}</p>
    }
    @if (numberGroup.controls.numberOutput?.errors?.min && numberGroup.touched) {
      <p class="validation-text text-center pb-0">This field should be at least {{item.templateOptions.min}}</p>
    }
    @if (numberGroup.controls.numberOutput?.errors?.max && numberGroup.touched) {
      <p class="validation-text text-center pb-0">This field should be at most {{item.templateOptions.max}}</p>
    }
  </div>

  <div style="position: absolute;bottom:2px;left:0;right:0;display:flex">
    @if (item.templateOptions.min || item.templateOptions.min == 0) {
      <label class="label-preview-title pb-3 ps-4">Min : {{item.templateOptions.min}}</label>
    }
    @if (item.templateOptions.max || item.templateOptions.max == 0) {
      <label class="label-preview-title ps-2 pb-3">Max : {{item.templateOptions.max}}</label>
    }
  </div>
</div>